import * as Yup from 'yup'

export const _beginformState = (function () {
  
  let utrn = "";
  let confirm = false;

  const getUtrn = function () { return utrn; };
  const setUtrn = function (name) { utrn = name; };
  const getConfirm = function () { return confirm; };
  const setConfirm = function (name) { confirm = name; };

  const resetBeginFormState = function () {
    setUtrn('');
    setConfirm(false);
  };

  return {
    getUtrn: getUtrn,
    setUtrn: setUtrn,
    getConfirm: getConfirm,
    setConfirm: setConfirm,
    resetBeginFormState: resetBeginFormState
  }

})();

const yupValidation = Yup.object().shape({
  confirm: Yup.boolean().oneOf([true], 'Select if you have read and understood the privacy notice'),
})

export const formOptions = yupValidation;